import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Globe } from 'lucide-react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#071E45] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 sm:pt-24 pb-12 sm:pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <img src="/logo-white.png" alt="Asküçükler Lojistik" className="h-12 w-auto mb-8 opacity-90" />
            <p className="text-white/45 text-sm leading-relaxed max-w-sm mb-8">
              Akaryakıt ve tehlikeli madde taşımacılığında kontrollü süreçler, disiplinli operasyonlar. 1998'den bu yana.
            </p>
            <div className="space-y-3">
              <a href="tel:+905305450170" className="flex items-center gap-3 text-white/40 hover:text-white/70 transition-colors text-sm">
                <Phone className="w-3.5 h-3.5" /><span>0530 545 01 70</span>
              </a>
              <a href="mailto:info@askucukler.com" className="flex items-center gap-3 text-white/40 hover:text-white/70 transition-colors text-sm">
                <Mail className="w-3.5 h-3.5" /><span>info@askucukler.com</span>
              </a>
              <div className="flex items-start gap-3 text-white/40 text-sm">
                <MapPin className="w-3.5 h-3.5 mt-0.5" /><span>İbnisina Mah., Güvenlik Cad. No:68, Derince / Kocaeli</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 lg:col-start-7">
            <h4 className="text-white/70 font-semibold mb-6 text-xs uppercase tracking-[0.15em]">Kurumsal</h4>
            <ul className="space-y-3">
              {[{ n: 'Hakkımızda', h: '/kurumsal' }, { n: 'Misyon & Vizyon', h: '/kurumsal#misyon' }, { n: 'Değerlerimiz', h: '/kurumsal#degerler' }].map(l => (
                <li key={l.n}><Link to={l.h} className="footer-link">{l.n}</Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white/70 font-semibold mb-6 text-xs uppercase tracking-[0.15em]">Hizmetler</h4>
            <ul className="space-y-3">
              {[{ n: 'Akaryakıt Taşımacılığı', h: '/hizmetler/akaryakit' }, { n: 'ADR Tehlikeli Madde', h: '/hizmetler/adr' }, { n: 'Lojistik Operasyonlar', h: '/hizmetler/lojistik' }, { n: 'Filo Takip', h: '/hizmetler/filo-takip' }].map(l => (
                <li key={l.n}><Link to={l.h} className="footer-link">{l.n}</Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white/70 font-semibold mb-6 text-xs uppercase tracking-[0.15em]">Hızlı Erişim</h4>
            <ul className="space-y-3">
              {[{ n: 'Filo & Teknoloji', h: '/filo-teknoloji' }, { n: 'Güvenlik & Kalite', h: '/guvenlik-kalite' }, { n: 'Referanslar', h: '/referanslar' }, { n: 'İletişim', h: '/iletisim' }].map(l => (
                <li key={l.n}><Link to={l.h} className="footer-link">{l.n}</Link></li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/6">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-white/30 text-xs">&copy; {year} Asküçükler Lojistik. Tüm hakları saklıdır.</p>
            <div className="flex items-center gap-6">
              <Link to="/gizlilik" className="text-white/30 text-xs hover:text-white/50 transition-colors">Gizlilik Politikası</Link>
              <Link to="/kvkk" className="text-white/30 text-xs hover:text-white/50 transition-colors">KVKK</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
